import AuthValid from './AuthValid'

export default AuthValid
